import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
  code: "km",
  messages: {
    inputMenu: {
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1",
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      create: '\u1794\u1784\u17D2\u1780\u17BE\u178F "{label}"'
    },
    calendar: {
      prevYear: "\u1786\u17D2\u1793\u17B6\u17C6\u1798\u17BB\u1793",
      nextYear: "\u1786\u17D2\u1793\u17B6\u17C6\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB",
      prevMonth: "\u1781\u17C2\u1798\u17BB\u1793",
      nextMonth: "\u1781\u17C2\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB"
    },
    inputNumber: {
      increment: "\u1794\u1784\u17D2\u1780\u17BE\u1793",
      decrement: "\u1794\u1793\u17D2\u1790\u1799"
    },
    commandPalette: {
      placeholder: "\u179C\u17B6\u1799\u1796\u17B6\u1780\u17D2\u1799\u1794\u1789\u17D2\u1787\u17B6 \u17AC\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780...",
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1",
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      close: "\u1794\u17B7\u1791"
    },
    selectMenu: {
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1",
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      create: '\u1794\u1784\u17D2\u1780\u17BE\u178F "{label}"',
      search: "\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780..."
    },
    toast: {
      close: "\u1794\u17B7\u1791"
    },
    carousel: {
      prev: "\u1798\u17BB\u1793",
      next: "\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB",
      goto: "\u179B\u17C4\u178F\u1791\u17C5\u1780\u17B6\u1793\u17CB\u179F\u17D2\u179B\u17B6\u1799 {slide}"
    },
    modal: {
      close: "\u1794\u17B7\u1791"
    },
    slideover: {
      close: "\u1794\u17B7\u1791"
    },
    alert: {
      close: "\u1794\u17B7\u1791"
    },
    table: {
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799"
    }
  }
});
